import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductsSelectorActions } from "./products-selector.actions";
import { ProductsSelectorPartialStoreState } from "./products-selector.reducer";

import * as selectors from './products-selector.selectors';

@Injectable()
export class ProductsSelectorFacade {
    selected$: Observable<Map<number, number>> = this.store.select(selectors.getSelected);

    constructor(
        private store: NgRedux<ProductsSelectorPartialStoreState>,
        private actions: ProductsSelectorActions
    ) { }

    addProduct(productId: number) {
        this.store.dispatch(this.actions.addProduct(productId));
    }

    removeProduct(productId: number) {
        this.store.dispatch(this.actions.removeProduct(productId));
    }

    resetSelected() {
        this.store.dispatch(this.actions.clearSelectedProducts());
    }
}
